// src/store/store.js
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import dealerReducer from '../features/dealers/dealerSlice';
import authReducer from '../features/auth/loginSlice';
import deviceReducer from '../features/devices/deviceSlice';
import clientsReducer from '../features/clients/clientsSlice';
import officesReducer from '../features/offices/officesSlice';
import techniciansReducer from '../features/technicians/technicianSlice';
import paymentReducer from "../features/payments/paymentSlice";
import reportsReducer from "../features/reports/reportsSlice";
import dashboardReducer from '../features/dashboard/dashboardSlice';
import sidebarReducer from '../features/sidebar/sidebarSlice';
import removalsReducer from '../features/removals/removalsSlice';

const appReducer = combineReducers({
    dealers: dealerReducer,
    auth: authReducer,
    devices: deviceReducer,
    clients: clientsReducer,
    offices: officesReducer,
    technicians: techniciansReducer,
    payments: paymentReducer,
    reports: reportsReducer,
    dashboard: dashboardReducer,
    sidebar: sidebarReducer,
    removals: removalsReducer,
});

// Remove in-memory records from the prior session before a different user
// signs in, so protected tables cannot briefly display cached user data.
const rootReducer = (state, action) => {
  if (action.type === 'auth/logout/fulfilled' || action.type === 'auth/resetAuthState') {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          'auth/login/fulfilled', 
          'auth/fleetLogin/fulfilled',
          'sidebar/checkDealerPayment/fulfilled'
        ],
        ignoredPaths: ['payload.headers', 'payload.config'],
      },
    }),
});
